var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row model-list"},_vm._l((_vm.itemsFromSelectedGroup),function(item){return _c('model-card',{key:item.make.name + item.MODNameGrp1 + item.body_type + item.MODBegin,attrs:{"model":item,"page":_vm.page}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }